import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import WithdrawCurrencySection from './WithdrawCurrencySection'
import CashCard from 'components/ui-kit/CashCard'

// Double background (padding-box fill + border-box gradient) paints the gold
// border. Keep each arbitrary class as one unbroken literal for Tailwind.
const WALLET_CARD =
  'mb-1 w-full box-border px-1 rounded-lg border border-solid border-transparent ' +
  'shadow-[inset_0_1px_0_rgb(var(--pm-gold)/0.06)] animate-pm-fade-in-up motion-reduce:animate-none ' +
  '[transition:box-shadow_var(--pm-duration-fast,0.16s)_var(--pm-ease,ease),transform_var(--pm-duration,0.24s)_var(--pm-ease-spring,ease)] ' +
  '[background:linear-gradient(145deg,#472e00,#090b0b_25%)_padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500)_border-box] ' +
  'hover:-translate-y-0.5 ' +
  'hover:[background:linear-gradient(145deg,#472e00,#090b0b_35%)_padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500)_border-box] ' +
  'hover:shadow-[inset_0_1px_0_rgb(var(--pm-gold)/0.1),0_6px_18px_rgb(var(--color-shadow)/0.18)]'

const CashierWithdraw = () => {
  const { t } = useTranslation()
  const { user } = useSelector((state) => state.user)
  const [selectedWithdrawWallet, setSelectedWithdrawWallet] = useState(null)

  return (
    <div
      id='pills-cashier-withdraw'
      role='tabpanel'
      aria-labelledby='pills-cashier-withdraw-tab'
      tabIndex='0'
    >
      {selectedWithdrawWallet
        ? (
          <WithdrawCurrencySection
            selectedWithdrawWallet={selectedWithdrawWallet}
            setSelectedWithdrawWallet={setSelectedWithdrawWallet}
          />
          )
        : (
          <div>
            <div className='mb-6 flex items-center max-md:mb-4 max-md:flex-col max-md:items-start max-md:gap-y-4'>
              <h3 className='mb-0 flex items-center text-xl font-bold uppercase text-white max-md:text-base'>{t('withdrawalOptions')}</h3>
            </div>
            <div>
              <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
                {user?.wallets
                  ?.filter((wallet) => !wallet.currency.isFiat && wallet.currency.isActive !== false)
                  ?.map((wallet) => (
                    <div
                      key={wallet.currencyId}
                      className={WALLET_CARD}
                    >
                      <CashCard
                        onClick={() => {
                          setSelectedWithdrawWallet(wallet)
                        }} title={wallet.currency.name} image={wallet.currency.image} desc={wallet.currency.code}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
          )}
    </div>
  )
}

export default CashierWithdraw
